import React, { memo } from 'react';
import { IoRestaurant } from 'react-icons/io5';
import type { MenuItem } from '../../services/menuService';

interface MenuItemCardProps {
  item: MenuItem;
  onClick?: (item: MenuItem) => void;
}

const MenuItemCard: React.FC<MenuItemCardProps> = ({ item, onClick }) => {
  // Display price as-is from API
  const price = (parseFloat(item.price) || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  const handleClick = () => {
    onClick?.(item);
  };

  return (
    <button
      onClick={handleClick}
      className="
        flex w-full items-center 
        gap-1.5 sm:gap-2 md:gap-2.5
        p-1.5 sm:p-2 md:p-2.5
        bg-[var(--bg-secondary)]
        border border-[var(--border-color)]
        rounded-lg
        hover:bg-[var(--bg-hover)]
        hover:shadow-sm
        active:scale-[0.98]
        transition-all duration-200
        text-left
      "
      aria-label={`${item.name} - $${price}`}
    >
      {/* Image */}
      <div className="w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 flex-shrink-0 rounded-lg overflow-hidden bg-[var(--bg-tertiary)] flex items-center justify-center">
        {item.image?.trim() ? (
          <img
            src={item.image}
            alt={item.name}
            loading="lazy"
            className="w-full h-full object-cover"
          />
        ) : (
          <IoRestaurant className="w-7 h-7 text-[var(--text-secondary)] opacity-30" />
        )}
      </div>

      {/* Content */}
      <div className="flex flex-col flex-1 min-w-0">
        <h3 className="text-xs sm:text-xs md:text-sm font-semibold text-[var(--text-primary)] truncate mb-0">
          {item.name}
        </h3>

        <span className="text-xs sm:text-sm md:text-base font-bold text-[#EF4421]">
          ${price}
        </span>
      </div>
    </button>
  );
};

export default memo(MenuItemCard);
